import { Component, inject, Input } from '@angular/core';
import {
  faHatCowboy,
  faTshirt,
  faMugSaucer,
  faBottleWater,
  faTag,
  faKey,
  faFire
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Router } from '@angular/router';
import { ProductCategory } from '../../models/product-category';
@Component({
  selector: 'app-category',
  imports: [FontAwesomeModule],
  templateUrl: './category.html',
  styleUrl: './category.scss'
})
export class Category {
  @Input() name!: string;
  icon: any;
  categoryImage: string = '';

  ngOnInit() {
    switch (this.name) {
      case ProductCategory.CAPS:
        this.icon = faHatCowboy;
        this.categoryImage = 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?auto=format&fit=crop&w=600&q=80';
        break;
      case ProductCategory.TSHIRTS:
        this.icon = faTshirt;
        this.categoryImage = 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=600&q=80';
        break;
      case ProductCategory.MUGS:
        this.icon = faMugSaucer;
        this.categoryImage = 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=600&q=80';
        break;
      case ProductCategory.BOTTLES:
        this.icon = faBottleWater;
        this.categoryImage = 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?auto=format&fit=crop&w=600&q=80';
        break;
      case ProductCategory.RESINKEYCHAIN:
        this.icon = faTag;
        this.categoryImage = 'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?auto=format&fit=crop&w=600&q=80';
        break;
      case ProductCategory.TRENDINGPRODUCTS:
        this.icon = faFire;
        this.categoryImage = 'https://images.unsplash.com/photo-1468495244123-6c6c332eeece?auto=format&fit=crop&w=600&q=80';
        break;
      default:
        this.icon = faTag;
        this.categoryImage = './home/1.png';
    }
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.style.display = 'none';
  }
}
